export default __webpack_public_path__ + "static/media/grafema_capitolio_03.e8201fd6.jpg";